import { createGlobalState, useLocalStorage } from "@vueuse/core";
import { FavoriteSearch } from "search/favoriteSearch";
import { computed, ComputedRef } from "vue";

export interface BalloonPosition {
  positionY: string;
  arrowAdjust: number;
}
const defaultBalloonPosition = {
  positionY: "",
  arrowAdjust: 0,
};

export const searchBalloonStore = createGlobalState(() => {
  const balloonPositionStorage = useLocalStorage<BalloonPosition>("BALLOON_POSITION", defaultBalloonPosition);
  const hoveredFavoriteSearchStorage = useLocalStorage<FavoriteSearch>("BALLOON_HOVERED_FAVORITE_SEARCH", null);
  const isBalloonHoverStorage = useLocalStorage<boolean>("BALLOON_IS_HOVERED", false);

  const balloonPosition: ComputedRef<BalloonPosition> = computed(() => balloonPositionStorage.value);
  const hoveredSearch: ComputedRef<FavoriteSearch> = computed(() => hoveredFavoriteSearchStorage.value);
  const isBalloonHover: ComputedRef<boolean> = computed(() => isBalloonHoverStorage.value);

  const setPosition = (position: BalloonPosition) => {
    balloonPositionStorage.value = position;
  };
  const setHoveredSearch = (favoriteSearch: FavoriteSearch) => {
    hoveredFavoriteSearchStorage.value = favoriteSearch;
  };
  const setIsBalloonHover = (isBalloonHover: boolean) => {
    isBalloonHoverStorage.value = isBalloonHover;
  };
  return { balloonPosition, hoveredSearch, isBalloonHover, setPosition, setHoveredSearch, setIsBalloonHover };
});
